import groupBy from "lodash/groupBy";
import Helper from "./helper";
import HomeChart from "../../../../helper/homechart.helper";

const PerformanceHelper = {
  // portfolio growth table data modify
  portfolio_growth_table: ({
    HistMetricsLive,
    compare_histmetrics,
    newBenchmarkName,
    display_orig_portfolio,
    model_name,
  }) => {
    if (HistMetricsLive.length) {
      var performance = HomeChart.renderPerformance(HistMetricsLive);
      var annualize = HomeChart.renderAnnualizedBacktestChart(
        "",
        HistMetricsLive,
        compare_histmetrics
      );

      if (newBenchmarkName) {
        let x = [display_orig_portfolio ? "Benchmark *" : "Original Portfolio"];
        let y = [`IQCIO Portfolio  ${model_name ? "+" : ""}`];
        let z = [
          display_orig_portfolio ? "Original Portfolio" : newBenchmarkName,
        ];

        x.push(...annualize.bm_data.slice(1));
        y.push(...annualize.fund_data.slice(1));

        let final = [y, x];

        if (compare_histmetrics && compare_histmetrics.length > 0) {
          z.push(...annualize.client_fund.slice(1));

          final.push(z);
        }

        return {
          portfolio_growth_table_heading: annualize.cats,
          portfolio_growth_table_data: final,
        };
      } else if (HistMetricsLive[0].type == "LIVE") {
        return {
          portfolio_growth_table_heading: performance[0],
          portfolio_growth_table_data: performance[1],
        };
      } else {
        if (compare_histmetrics && compare_histmetrics.length > 0) {
          let x = [`${newBenchmarkName}*`];
          let y = [`IQCIO Portfolio +`];
          let z = ["Benchmark"];

          x.push(...annualize.bm_data.slice(1));
          y.push(...annualize.fund_data.slice(1));

          let final = [y, x];

          if (compare_histmetrics && compare_histmetrics.length > 0) {
            z.push(...annualize.client_fund.slice(1));

            final.push(z);
          }

          return {
            portfolio_growth_table_heading: annualize.cats,
            portfolio_growth_table_data: final,
          };
        } else {
          let final = [
            ["Portfolio", ...annualize.fund_data.slice(1)],
            ["Benchmark", ...annualize.bm_data.slice(1)],
          ];

          return {
            portfolio_growth_table_heading: annualize.cats,
            portfolio_growth_table_data: final,
          };
        }
      }
    }
  },
  //---------------------------------
  return_volatility_modifier: ({
    getRiskStatistics,
    original_riskStatistics,
  }) => {
    let groupBy_getRiskStatistics = [];
    let groupBy_clientRiskStatistics = [];

    if (
      (getRiskStatistics && getRiskStatistics.length) ||
      (original_riskStatistics && original_riskStatistics.length)
    ) {
      if (getRiskStatistics.length === 0) return;
      let obj1 = {
          metric_name: "Return",
        },
        obj2 = {
          metric_name: "Volatility",
        };

      let pdfTableData = [];
      groupBy_getRiskStatistics = groupBy(
        getRiskStatistics,
        (obj) => obj.metric_name
      );
      groupBy_clientRiskStatistics = groupBy(
        original_riskStatistics,
        (obj) => obj.metric_name
      );

      let return_portfolio = (
        groupBy_getRiskStatistics["Annualized Return"][0]["fund"] * 100
      ).toFixed(2);
      let return_benchmark = (
        groupBy_getRiskStatistics["Annualized Return"][0]["benchmark"] * 100
      ).toFixed(2);
      let volatility_portfolio = (
        groupBy_getRiskStatistics["Annualized Vol"][0]["fund"] * 100
      ).toFixed(2);
      let volitility_benchmark = (
        groupBy_getRiskStatistics["Annualized Vol"][0]["benchmark"] * 100
      ).toFixed(2);

      obj1["Portfolio"] = return_portfolio;
      obj1["Benchmark"] = return_benchmark;
      obj2["Portfolio"] = volatility_portfolio;
      obj2["Benchmark"] = volitility_benchmark;

      // pdf table data
      if (getRiskStatistics) {
        let portfolio = [];
        let benchmark = [];
        let original = [];

        portfolio.push(
          "Portfolio",
          return_portfolio + "%",
          volatility_portfolio + "%"
        );
        benchmark.push(
          "Benchmark",
          return_benchmark + "%",
          volitility_benchmark + "%"
        );

        if (original_riskStatistics.length > 0) {
          let r3 = (
            groupBy_clientRiskStatistics["Annualized Return"][0]["fund"] * 100
          ).toFixed(2);
          let v3 = (
            groupBy_clientRiskStatistics["Annualized Vol"][0]["fund"] * 100
          ).toFixed(2);
          portfolio[0] = "IQCIO Model";

          original.push("Original Portfolio", r3 + "%", v3 + "%");
          pdfTableData.push(portfolio, benchmark, original);

          obj1["Original Portfolio"] = r3;
          obj2["Original Portfolio"] = v3;
        } else {
          pdfTableData.push(portfolio, benchmark);
        }
      }

      let final_data = [{ ...obj1 }, { ...obj2 }];

      return { final_data, pdfTableData };
    } else {
      return { final_data: [], pdfTableData: [] };
    }
  },

  portfolio_return_table: ({
    getRiskStatistics,
    original_riskStatistics,
    model_name,
    typeName,
  } = []) => {
    // setting one more column if flow is from create  portfolio ajax_compare_portfolio
    // adding benchmark to column
    const mergeData = Helper.mergeData(
      getRiskStatistics,
      original_riskStatistics
    );
    const tableListOfArrays = Helper.portfolioReturnDataModify(mergeData);

    if (original_riskStatistics && original_riskStatistics.length > 0) {
      let iqcio_portfolio = model_name
        ? "IQCIO Portfolio +"
        : "IQCIO Portfolio";
      let columns = [
        { title: "Risk" },
        { title: iqcio_portfolio },
        { title: `Benchmark *` },
        { title: "Original Portfolio" },
      ];

      return {
        portfolio_return_table_heading: columns,
        portfolio_return_table_data: tableListOfArrays,
      };
    } else {
      let columns = [
        { title: "Risk" },
        { title: "Portfolio" },
        { title: `${typeName}` },
      ];
      return {
        portfolio_return_table_heading: columns,
        portfolio_return_table_data: tableListOfArrays,
      };
    }
  },

  // -------------annualized backtest data ------------------
  annualized_getSpecificData: ({
    data,
    key1 = "portfolio",
    key2 = "benchmark",
  }) => {
    const newArray = [];
    if (!data) return;
    for (let i in data) {
      let line = data[i];
      let fd = parseFloat((parseFloat(line.fund_return) * 100).toFixed(2));
      let bm = parseFloat((parseFloat(line.bm_return) * 100).toFixed(2));
      switch (line.metric_name) {
        case "1 Year":
          if (newArray.indexOf("1 Year") === -1)
            newArray.push({
              metric_name: "1 Year",
              [key1]: fd,
              [key2]: bm,
            });
          break;
        case "3 Year":
          if (newArray.indexOf("3 Year") === -1)
            newArray.push({
              metric_name: "3 Year",
              [key1]: fd,
              [key2]: bm,
            });
          break;
        case "5 Year":
          if (newArray.indexOf("5 Year") === -1)
            newArray.push({
              metric_name: "5 Year",
              [key1]: fd,
              [key2]: bm,
            });
          break;
        case "Since Inception":
          if (newArray.indexOf("Since Inception") === -1)
            newArray.push({
              metric_name: "Since Inception",
              [key1]: fd,
              [key2]: bm,
            });
          break;
        default:
      }
    }
    return newArray;
  },
  annualized_mergeData: (target, source, prop) => {
    let data = [];
    source.forEach((sourceElement) => {
      let targetElement = target.find((targetElement) => {
        return sourceElement[prop] === targetElement[prop];
      });
      targetElement
        ? Object.assign(targetElement, sourceElement)
        : target.push(sourceElement);
      data.push(targetElement);
    });

    let x = data.map((e) => {
      let obj = {};
      obj["metric_name"] = e["metric_name"];
      obj["portfolio"] = e["portfolio"];
      obj["benchmark"] = e["benchmark"];
      obj["Original portfolio"] = e["Orginal_Portfolio"];
      return obj;
    });
    return x;
  },
  annualized_modifyData: ({ data, client_data, display_orig_portfolio }) => {
    let base_data = PerformanceHelper.annualized_getSpecificData({
      data,
      key1: "portfolio",
      key2: "benchmark",
    });
    let modified_client_data = PerformanceHelper.annualized_getSpecificData({
      data: client_data,
      key1: "Orginal_Portfolio",
      key2: "Orginal_Benchmark",
    });
    if (display_orig_portfolio === true && client_data.length > 0) {
      // merge data
      let pdf_heading = [{ title: "" }],
        annualized_yearly_pdf_data = [];
      let data = PerformanceHelper.annualized_mergeData(
        base_data,
        modified_client_data,
        "metric_name"
      );
      let p = ["IQCIO model"],
        b = ["Benchmark"],
        o = ["Original portfolio"];
      for (let i = 0; i < data.length; i++) {
        if (data[i]["portfolio"]) {
          p.push(data[i]["portfolio"].toFixed(2) + "%");
        } else {
          p.push("-");
        }
        if (data[i]["benchmark"]) {
          b.push(data[i]["benchmark"].toFixed(2) + "%");
        } else {
          b.push("-");
        }
        if (data[i]["Original portfolio"]) {
          let val = data[i]["Original portfolio"]
            ? data[i]["Original portfolio"].toFixed(2) + "%"
            : 0;
          o.push(val);
        } else {
          o.push("-");
        }

        pdf_heading.push({ title: data[i]["metric_name"] });
      }
      annualized_yearly_pdf_data.push(p, b, o);

      return {
        data,
        annualized_yearly_pdf_heading: pdf_heading,
        annualized_yearly_pdf_data,
      };
    } else {
      let pdf_heading = [{ title: "" }];
      let annualized_yearly_pdf_data = [];
      let p = ["Portfolio"],
        b = ["Benchmark"];
      for (let i = 0; i < base_data.length; i++) {
        if (base_data[i]["portfolio"]) {
          p.push(base_data[i]["portfolio"].toFixed(2) + "%");
        } else {
          p.push("-");
        }
        if (base_data[i]["benchmark"]) {
          b.push(base_data[i]["benchmark"].toFixed(2) + "%");
        } else {
          b.push("-");
        }

        pdf_heading.push({ title: base_data[i]["metric_name"] });
      }
      annualized_yearly_pdf_data.push(p, b);
      return {
        data: base_data,
        annualized_yearly_pdf_heading: pdf_heading,
        annualized_yearly_pdf_data,
      };
    }
  },
  // -------------calender year ----------------------------
  calender_year_getSpecificData: ({
    data,
    key1 = "portfolio",
    key2 = "benchmark",
  } = {}) => {
    let values = [];

    for (let i in data) {
      let line = data[i];
      let year = parseInt(line.metric_name);

      if (year >= 2012) {
        values.push({
          metric_name: year,
          [key1]: parseFloat([line.fund_return * 100]),
          [key2]: parseFloat([line.bm_return * 100]),
        });
      }
    }
    values.sort((a, b) => parseInt(b.metric_name) - parseInt(a.metric_name));
    return values;
  },
  calender_year_merge: (target, source, prop) => {
    let data = [];
    source.forEach((sourceElement) => {
      let targetElement = target.find((targetElement) => {
        return sourceElement[prop] === targetElement[prop];
      });
      targetElement
        ? Object.assign(targetElement, sourceElement)
        : target.push(sourceElement);
      data.push(targetElement);
    });
    return data;
  },
  calender_year_modifiedOrginalData: (data) => {
    if (!data) return;
    let d = data.filter((e) => e);
    let x = [];
    d.map((e, i) => {
      if ("Original benchmark" in d[i]) {
        delete d[i]["Original benchmark"];
        x.push(e);
      }
    });
    return x;
  },
  calendar_year_backtest_performance: ({
    getPerfHistMetrics,
    clientHistmetrics,
  } = []) => {
    let data1 = PerformanceHelper.calender_year_getSpecificData({
      data: getPerfHistMetrics,
      key1: "portfolio",
      key2: "benchmark",
    });
    // let calendar_yearly_pdf_heading = data1.map((e) => e.metric_name + "");

    if (!clientHistmetrics && clientHistmetrics.length == 0) {
      let calendar_yearly_pdf_data = [];
      let pdf_heading = [{ title: "" }];
      if (data1.length) {
        let p = ["Portfolio"],
          b = ["Benchmark"];
        for (let i = 0; i < data1.length; i++) {
          if (data1[i]["portfolio"]) {
            p.push(data1[i]["portfolio"].toFixed(2) + "%");
          } else {
            p.push("-");
          }
          if (data1[i]["benchmark"]) {
            b.push(data1[i]["benchmark"].toFixed(2) + "%");
          } else {
            b.push("-");
          }
          pdf_heading.push({ title: data1[i]["metric_name"] });
        }
        calendar_yearly_pdf_data.push(p, b);
      }
      return {
        data: data1,
        calendar_yearly_pdf_heading: pdf_heading,
        calendar_yearly_pdf_data,
      };
      // this.setState({
      //   monthlyPerformance: data1,
      // });
    } else if (clientHistmetrics && clientHistmetrics.length > 0) {
      let data2 = PerformanceHelper.calender_year_getSpecificData({
        data: clientHistmetrics,
        key1: "Original portfolio",
        key2: "Original benchmark",
      });
      let modified_orginal_data = PerformanceHelper.calender_year_merge(
        data1,
        data2,
        "metric_name"
      );
      let x = PerformanceHelper.calender_year_modifiedOrginalData(
        modified_orginal_data
      );

      //add remaining non common
      let res = [];
      if (data1.length > data2.length) {
        res = data1
          .filter(function (ol) {
            return !x.some(function (o2) {
              return ol.metric_name === o2.metric_name;
            });
          })
          .map(function (o) {
            let obj = { ...o };
            // if (!"Orginal portfolio" in obj) {
            obj["Original portfolio"] = 0;
            // }
            return obj;
          });
      } else {
        res = data2
          .filter(function (ol) {
            return !x.some(function (o2) {
              return ol.metric_name === o2.metric_name;
            });
          })
          .map(function (o) {
            let obj = {};
            // if (!"Orginal portfolio" in obj) {
            obj["portfolio"] = 0;
            obj["benchmark"] = 0;
            obj["Original portfolio"] = o["Original portfolio"];
            obj["metric_name"] = o["metric_name"];
            // }
            return obj;
          });
      }
      let final = [...res, ...x];
      final.sort((a, b) => a.metric_name - b.metric_name);

      let calendar_yearly_pdf_data = [];
      let pdf_heading = [{ title: "" }];
      if (final.length) {
        let p = ["IQCIO model"],
          b = ["Benchmark"],
          o = ["Original portfolio"];
        for (let i = 0; i < final.length; i++) {
          if (final[i]["portfolio"]) {
            p.push(final[i]["portfolio"].toFixed(2) + "%");
          } else {
            p.push("-");
          }
          if (final[i]["benchmark"]) {
            b.push(final[i]["benchmark"].toFixed(2) + "%");
          } else {
            b.push("-");
          }
          if (final[i]["Original portfolio"]) {
            let val = final[i]["Original portfolio"]
              ? final[i]["Original portfolio"].toFixed(2) + "%"
              : 0;
            o.push(val);
          } else {
            o.push("-");
          }
          pdf_heading.push({ title: final[i]["metric_name"] });
        }
        calendar_yearly_pdf_data.push(p, b, o);
      }

      // let pdf_heading = final.map((e) => e.metric_name + "");
      return {
        data: final,
        calendar_yearly_pdf_heading: pdf_heading,
        calendar_yearly_pdf_data,
      };
    } else {
      let calendar_yearly_pdf_data = [];
      let pdf_heading = [{ title: "" }];
      if (data1.length) {
        let p = ["Portfolio"],
          b = ["Benchmark"];
        for (let i = 0; i < data1.length; i++) {
          if (data1[i]["portfolio"]) {
            p.push(data1[i]["portfolio"].toFixed(2) + "%");
          } else {
            p.push("-");
          }
          if (data1[i]["benchmark"]) {
            b.push(data1[i]["benchmark"].toFixed(2) + "%");
          } else {
            b.push("-");
          }

          pdf_heading.push({ title: data1[i]["metric_name"] });
        }
        calendar_yearly_pdf_data.push(p, b);
      }
      return {
        data: data1,
        calendar_yearly_pdf_heading: pdf_heading,
        calendar_yearly_pdf_data,
      };
    }
  },

  // ---------------------------------------------------
};
export default PerformanceHelper;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/performance.helper.js